const cache = new Map<string, Promise<[number, number][]>>()

export function gridToCoords(grid: number) {
  const u16 = new Uint16Array([grid, grid >> 16]);
  const lon = 5 + ((u16[0] + 0.5) * 15) / 65536;
  const lat = 36 + ((u16[1] + 0.5) * 12) / 65536;

  return { lat, lon };
}

export function statsToPoints(stats: {[grid: string]: number}) {
  const points: [number, number][] = [];

  for (const gridStr in stats) {
    const grid = parseInt(gridStr);
    const count = stats[gridStr];
    const {lon, lat} = gridToCoords(grid);

    for (let i = 0; i < count; i++) {
      points.push([lon, lat]);
    }
  }

  return points;
}

export function loadSingleWordData(url: string): Promise<[number, number][]> | null {
  if(!url) return null;

  const cached = cache.get(url)
  if(cached) return cached
  
  const promise = new Promise<[number, number][]>((resolve) => {
    return fetch(url).then((response) => response.arrayBuffer())
      .then(buffer => {
        const u32 = new Uint32Array(buffer);

        const points: [number, number][] = [];

        for (const grid of u32) {
          const {lon, lat} = gridToCoords(grid);
          points.push([lon, lat])
        }

        resolve(points)
      })
  })
  cache.set(url, promise)
  return promise
}


export function loadWordData(urls: string[] | string) {
  if(!urls) {
    return []
  } else {

    if(Array.isArray(urls)) {
      return Promise.all(urls.map(loadSingleWordData))
    } else {
      return loadSingleWordData(urls)
    }
  }
}
